import { IconButton } from '@cian/ui-kit';
import { IconFunctionalWarningCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { MessageErrorMenu } from '../../../../components/MessageErrorMenu';
import { ERequestApiStatus } from '../../../../types/appState';
import { TMessage, TOutcomingStatus } from '../../../../types/messages';

interface IErrorSignContainerProps {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
}

export const ErrorSignContainer: React.FC<IErrorSignContainerProps> = ({ message: { status }, messageId }) => {
  const [showErrorMenu, setShowErrorMenu] = React.useState(false);

  const iconRef = React.useRef<HTMLButtonElement>(null);

  const handleSetShowErrorMenu = React.useCallback(() => {
    setShowErrorMenu(!showErrorMenu);
  }, [showErrorMenu]);

  if (status !== ERequestApiStatus.Failed) {
    return null;
  }

  return (
    <>
      <IconButton
        ref={iconRef}
        data-name="ErrorSignNode"
        icon={<IconFunctionalWarningCircle16 />}
        onClick={handleSetShowErrorMenu}
      />
      {showErrorMenu && (
        <MessageErrorMenu messageId={messageId} buttonRef={iconRef} closeMenu={handleSetShowErrorMenu} />
      )}
    </>
  );
};
